import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IMG_CAMINHO } from 'src/app/app.api';
import { Apartamento } from 'src/app/shared/model/apartamento.model';
import { AtributoAdicional } from 'src/app/shared/model/atributo-adicional.model';
import { ClienteProjeto } from 'src/app/shared/model/cliente-projeto.model';
import { Cliente } from 'src/app/shared/model/cliente.model';
import { ComodoAtributoVariacao } from 'src/app/shared/model/comodo-atributo-variacao.model';
import { ComodoAtributo } from 'src/app/shared/model/comodo-atributo.model';
import { Comodo } from 'src/app/shared/model/comodo.model';
import { Contador } from 'src/app/shared/model/contador.model';
import { Navegacao } from 'src/app/shared/model/navegacao.model';
import { SegmentacaoOpcao } from 'src/app/shared/model/segmentacao-opcao.model';
import { DataService } from 'src/app/shared/service/data.service';
import { TimeNavigationService } from 'src/app/shared/service/time-navigation.service';

declare var $: any;

@Component({
  selector: 'dom436-configurator',
  templateUrl: './configurator.component.html'
})
export class ConfiguratorComponent implements OnInit, OnDestroy {

  isOpen1: boolean = true;
  isOpen2: boolean = false;
  isOpen3: boolean = false;
  isOpen4: boolean = false;
  isOpen5: boolean = false;
  previousOption: number = 0;
  selectedApartamento: Apartamento = null;
  selectedVariations: string[] = [];
  selectedAdditionals: number[] = [];
  selectedComodo: number = 1;
  additionalsSession: number[] = [];
  segmentacaoOpcoes: SegmentacaoOpcao[] = [];
  comodos: Comodo[] = [];
  comodosAtributos: ComodoAtributo[] = [];
  comodosAtributosVariacoes: ComodoAtributoVariacao[] = [];
  atributosAdicionais: AtributoAdicional[] = [];
  atributoAdicionalSelecionado: number = -1;
  habilitarAdicionaisMultiplasSelecoes: boolean = true;
  cliente: Cliente = {id: undefined, apartamento: undefined, corretor: undefined, segmento: undefined, valorBase: undefined, valorAdicional: undefined, valorTotal: undefined, codigoUrl: '', nome: '', cpf: '', email: '', telefone: '', celular: '', logradouro: '', numero: '', complemento: '', bairro: '', regiaoMunicipio: undefined, cep: '', status: undefined, createdAt: undefined, updatedAt: undefined};
  comodoOpen = 1;
  caminhoImg: string = null;
  valorBase: number = 0;
  valorAdicional: number = 0;
  valorTotal: number = 0;
  color: string = '#8e8e8e';
  optionsMobileEnabled: boolean = true;
  tipoAcesso: string = null;
  novoCliente: boolean = true;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    protected sanitizer: DomSanitizer,
    private timeNavigationService: TimeNavigationService
  ) {
    let codigoUrl = this.route.snapshot.params['codigoUrl'];
    this.selectedApartamento = JSON.parse(sessionStorage.getItem('selectedApartamento'));
    if(!this.selectedApartamento && !codigoUrl) {
      this.router.navigate(['/selecionar-apartamento']);
    }
    this.tipoAcesso = sessionStorage.getItem('tipoAcesso');
    if(!this.tipoAcesso && !codigoUrl || this.tipoAcesso !== 'teste' && !codigoUrl) {
      this.incrementarContador(this.selectedApartamento.id, 2);
    }
    let selectedSegmentId = null;
    let state = this.router.getCurrentNavigation().extras.state as {selectedSegment: string};
    if(codigoUrl && codigoUrl !== 'novo') {
      this.novoCliente = false;
      this.dataService.getClienteByCodigoUrl(codigoUrl)
        .subscribe(cliente => {
          this.cliente = cliente;
          sessionStorage.setItem('cliente', JSON.stringify(this.cliente));
          this.selectedApartamento = this.cliente.apartamento;
          sessionStorage.setItem('selectedApartamento', JSON.stringify(this.selectedApartamento));
          this.dataService.ListProjetoByCliente(cliente.id)
            .subscribe(clienteProjeto => {
              let clienteProjetoItens: ClienteProjeto[] = clienteProjeto;
              clienteProjetoItens.forEach(clienteProjeto => {
                if(clienteProjeto.comodo) {
                  if(clienteProjeto.cor && clienteProjeto.cor !== 'undefined') {
                    this.openVariation(clienteProjeto.comodo+'-'+clienteProjeto.comodoAtributo+'-'+clienteProjeto.comodoAtributoVariacao+'-'+clienteProjeto.cor);
                  } else {
                    this.openVariation(clienteProjeto.comodo+'-'+clienteProjeto.comodoAtributo+'-'+clienteProjeto.comodoAtributoVariacao);
                  }
                } else {
                  this.additionalsSession.push(clienteProjeto.atributoAdicional);
                }
              });
            });
        });
    } else if(state) {
      /*
      selectedSegmentId = state.selectedSegment;
      console.log(selectedSegmentId)
      this.dataService.getSegmentacaoOpcoes(selectedSegmentId)
        .subscribe(segmentacaoOpcoes => {
          this.segmentacaoOpcoes = segmentacaoOpcoes;
          this.segmentacaoOpcoes.forEach(segmentacaoOpcao => {
            this.openVariation(segmentacaoOpcao.comodo+'-'+segmentacaoOpcao.comodoAtributo+'-'+segmentacaoOpcao.comodoAtributoVariacao);
          });
          this.cliente.id = 999;
          this.cliente.apartamento = this.selectedApartamento;
          this.cliente.segmento = this.segmentacaoOpcoes[0].segmentacao.nome;
          sessionStorage.setItem('cliente', JSON.stringify(this.cliente));
        });
      */
      this.cliente.id = 99999;
      this.cliente.apartamento = this.selectedApartamento;
      sessionStorage.setItem('cliente', JSON.stringify(this.cliente));
    } else {
      this.cliente = JSON.parse(sessionStorage.getItem('cliente'));
      let clienteProjetoItens: ClienteProjeto[] = JSON.parse(sessionStorage.getItem('clienteProjeto'));
      clienteProjetoItens.forEach(clienteProjeto => {
        if(clienteProjeto.comodo) {
          if(clienteProjeto.cor && clienteProjeto.cor !== 'undefined') {
            this.openVariation(clienteProjeto.comodo+'-'+clienteProjeto.comodoAtributo+'-'+clienteProjeto.comodoAtributoVariacao+'-'+clienteProjeto.cor);
          } else {
            this.openVariation(clienteProjeto.comodo+'-'+clienteProjeto.comodoAtributo+'-'+clienteProjeto.comodoAtributoVariacao);
          }
        } else {
          this.additionalsSession.push(clienteProjeto.atributoAdicional);
        }
      });
    }
  }

  ngAfterViewInit(): void {
    $('.selectpicker').selectpicker('refresh');
  }

  ngOnInit(): void {
    this.caminhoImg = IMG_CAMINHO;
    this.sumTotal();
    if(!this.tipoAcesso || this.tipoAcesso !== 'teste') {
      this.timeNavigationService.setTime('timeInConfigurator', new Date());
    }
    this.dataService.listComodos()
      .subscribe(comodos => {
        this.comodos = comodos.filter(comodo => { return comodo.planta.id === this.selectedApartamento?.planta.id });
        this.comodoOpen = this.comodos[0]?.id;
      });
    this.dataService.listComodosAtributos()
      .subscribe(comodosAtributos => {
        this.comodosAtributos = comodosAtributos.filter(comodoAtributo => { return comodoAtributo.comodo.planta.id === this.selectedApartamento?.planta.id });
      });
    this.dataService.listComodosAtributosVariacoes()
      .subscribe(comodosAtributosVariacoes => { 
        this.comodosAtributosVariacoes = comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.comodoAtributo.comodo.planta.id === this.selectedApartamento?.planta.id; });
        this.sumValues();
      });
    this.dataService.listAtributosAdicionais()
      .subscribe(atributosAdicionais => {
        this.atributosAdicionais = atributosAdicionais.filter(atributo => atributo.status === true);
        this.checkAdditionalFromSession();
      });
  }

  ngOnDestroy(): void {
    const timeInConfigurator = this.timeNavigationService.getTime('timeInConfigurator');
    if(timeInConfigurator) {
      if(!this.tipoAcesso || this.tipoAcesso !== 'teste') {
        const duration = new Date().getTime() - timeInConfigurator.getTime();
        this.incrementarNavegacao(this.selectedApartamento.id, duration / 1000);
      }
    }
  }

  openOptionMobile(comodo:Comodo) {
    if(comodo !== undefined) {
      this.openOption(comodo.id);
    }
  }

  openOption(value) {
    this.selectedComodo = value;
    this.comodoOpen = value;
  }

  closeOptions() {
    this.comodoOpen = null;
  }

  accordionOptionClick(value) {
    if(value !== 'complementares') {
      this.openOption(value);
      this.previousOption = value;
    }
  }

  openVariation(value) {
    let valueArray = value.split('-');
    if(valueArray[0] === 'c') {
      let valueClean = valueArray[1]+'-'+valueArray[2];
      let index = this.selectedVariations.findIndex(v => {
        let valueSearchArray = v.split('-');
        let valueSearch = valueSearchArray[0]+'-'+valueSearchArray[1];
        return valueSearch.includes(valueClean);
      });
      if(index !== -1) {
        this.selectedVariations.splice(index, 1);
      }
    } else {
      let valueClean = valueArray[0]+'-'+valueArray[1];
      let index = this.selectedVariations.findIndex(v => {
        let valueSearchArray = v.split('-');
        let valueSearch = valueSearchArray[0]+'-'+valueSearchArray[1];
        return valueSearch.includes(valueClean);
      });
      if(index !== -1) {
        this.selectedVariations.splice(index, 1);
      }
      if(valueArray[3] && valueArray[3] !== 'undefined' && valueArray[3] !== '#8e8e8e') {
        this.selectedVariations.push(value+'-'+valueArray[3]);
      } else {
        this.selectedVariations.push(value);
      }
    }
    this.openSimilars(value);
    this.saveVariationSession();
    this.sumValues();
  }

  openSimilars(value) {
    let valueArray = value.split('-');
    if(valueArray[0] === 'c') {
      let comoAtributoSelected = this.comodosAtributos.filter(ComodoAtributo => { return ComodoAtributo.id === Number(valueArray[2]) })[0];
      let comoAtributoSimilars = this.comodosAtributos.filter(ComodoAtributo => { return ComodoAtributo.nome === comoAtributoSelected.nome });
      comoAtributoSimilars.forEach(comodoAtributoSimilar => {
        let valueClean = comodoAtributoSimilar.comodo.id+'-'+comodoAtributoSimilar.id;
        let index = this.selectedVariations.findIndex(v => {
          let valueSearchArray = v.split('-');
          let valueSearch = valueSearchArray[0]+'-'+valueSearchArray[1];
          return valueSearch.includes(valueClean);
        });
        if(index !== -1) {
          this.selectedVariations.splice(index, 1);
        }
      });
    } else {
      let comoAtributoVariacaoSelected = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id === Number(valueArray[2]) })[0];
      if(comoAtributoVariacaoSelected) {
        let comoAtributoVariacaoSimilars = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.nome === comoAtributoVariacaoSelected.nome && comodoAtributoVariacao.comodoAtributo.nome === comoAtributoVariacaoSelected.comodoAtributo.nome });
        comoAtributoVariacaoSimilars.forEach(ComodoAtributoVariacaoSimilar => {
          let valueClean = ComodoAtributoVariacaoSimilar.comodoAtributo.comodo.id+'-'+ComodoAtributoVariacaoSimilar.comodoAtributo.id;
          let index = this.selectedVariations.findIndex(v => {
            let valueSearchArray = v.split('-');
            let valueSearch = valueSearchArray[0]+'-'+valueSearchArray[1];
            return valueSearch.includes(valueClean);
          });
          if(index !== -1) {
            this.selectedVariations.splice(index, 1);
          }
          if(valueArray[3] && valueArray[3] !== 'undefined' && valueArray[3] !== '#8e8e8e') {
            this.selectedVariations.push(ComodoAtributoVariacaoSimilar.comodoAtributo.comodo.id+'-'+ComodoAtributoVariacaoSimilar.comodoAtributo.id+'-'+ComodoAtributoVariacaoSimilar.id+'-'+valueArray[3]);
          } else {
            this.selectedVariations.push(ComodoAtributoVariacaoSimilar.comodoAtributo.comodo.id+'-'+ComodoAtributoVariacaoSimilar.comodoAtributo.id+'-'+ComodoAtributoVariacaoSimilar.id);
          }
        });
      }
    }
    this.sumValues();
  }

  checkVariation(value) {
    let valueArray = value.split('-');
    let comodoAtributo = this.comodosAtributos.filter(comodoAtributo => { return comodoAtributo.id === Number(valueArray[1]) })[0];
    if(comodoAtributo && comodoAtributo.status === false) {
      let comodoAtributoByNome = this.comodosAtributos.filter(comodoAtributoByNome => { return comodoAtributoByNome.status === true && comodoAtributoByNome.nome === comodoAtributo.nome })[0];
      if(comodoAtributoByNome.status === true) {
        let index = this.selectedVariations.findIndex(v => v.includes(comodoAtributoByNome.comodo.id+'-'+comodoAtributoByNome.id));
        if(index !== -1) {
          let selectedVariation = this.selectedVariations[index];
          let selectedVariationArray = selectedVariation.split('-');
          // Fix temporário para problema de variação estar aparecendo dentro do atributo e comodo errado.
          if(valueArray[2] === '450' || selectedVariationArray[2] === '450' ||
            valueArray[2] === '451' || selectedVariationArray[2] === '451' ||
            valueArray[2] === '452' || selectedVariationArray[2] === '452') {
            if(this.comodoOpen !== 29) {
              return false;
            }
          }
          let comoAtributoVariacaoCheck = this.comodosAtributosVariacoes.filter(ComodoAtributoVariacao => { return ComodoAtributoVariacao.id === Number(valueArray[2]) })[0];
          let comoAtributoVariacaoSelected = this.comodosAtributosVariacoes.filter(ComodoAtributoVariacao => { return ComodoAtributoVariacao.id === Number(selectedVariationArray[2]) })[0];
          if(comoAtributoVariacaoCheck.nome === comoAtributoVariacaoSelected.nome) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      let index = this.selectedVariations.findIndex(v => v.includes(value));
      let valueFoundArray = [];
      if(index !== -1) {
        let valueFound = this.selectedVariations[index];
        valueFoundArray = valueFound.split('-');
      }
      if(index !== -1 && valueArray[0] === this.selectedComodo.toString() && valueArray[2] === valueFoundArray[2]) {
        return true;
      } else {
        return false;
      }
    }
  }

  changeVariationColor(color, variationValue) {
    let index = this.selectedVariations.findIndex(v => v.includes(variationValue));
    if(index !== -1) {
      this.selectedVariations.splice(index, 1);
      this.selectedVariations.push(variationValue+'-'+color);
      let valueArray = variationValue.split('-');
      let comoAtributoVariacaoSelected = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id === Number(valueArray[2]) })[0];
      if(comoAtributoVariacaoSelected) {
        let comoAtributoVariacaoSimilars = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.nome === comoAtributoVariacaoSelected.nome && comodoAtributoVariacao.comodoAtributo.nome === comoAtributoVariacaoSelected.comodoAtributo.nome });
        comoAtributoVariacaoSimilars.forEach(ComodoAtributoVariacaoSimilar => {
          let valueClean = ComodoAtributoVariacaoSimilar.comodoAtributo.comodo.id+'-'+ComodoAtributoVariacaoSimilar.comodoAtributo.id;
          let index = this.selectedVariations.findIndex(v => {
            let valueSearchArray = v.split('-');
            let valueSearch = valueSearchArray[0]+'-'+valueSearchArray[1];
            return valueSearch.includes(valueClean);
          });
          if(index !== -1) {
            this.selectedVariations.splice(index, 1);
          }
          this.selectedVariations.push(ComodoAtributoVariacaoSimilar.comodoAtributo.comodo.id+'-'+ComodoAtributoVariacaoSimilar.comodoAtributo.id+'-'+ComodoAtributoVariacaoSimilar.id+'-'+color);
        });
      }
      this.saveVariationSession();
    }

  }

  getColor(value, mode) {
    let index = this.selectedVariations.findIndex(v => v.includes(value));
    if(index !== -1) {
      let variationValue = this.selectedVariations[index];
      let variationValueArray = variationValue.split('-');
      let color = variationValueArray[3];
      if(color || color === 'undefined') {
        return color;
      } else {
        if(mode === 'selector') {
          return 'url(assets/images/color-picker.jpg)';
        } else {
          return '#8e8e8e';
        }
      }
    } else {
      if(mode === 'selector') {
        return 'url(assets/images/color-picker.jpg)';
      } else {
        return '#8e8e8e';
      }
    }
  }

  sumValues() {
    let sumBaseValue = 0;
    let nomesAnteriores = [];
    this.selectedVariations.forEach(value => {
      let valueArray = value.split('-');
      let comodoAtributoVariacao = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id.toString() === valueArray[2] })[0];
      if(comodoAtributoVariacao && nomesAnteriores.findIndex(v => v.includes(comodoAtributoVariacao.nome)) === -1) {
        let comodoAtributoValorUnitario = comodoAtributoVariacao.comodoAtributo.valorUnitario;
        let comodoAtributoVariacaoPreco = comodoAtributoVariacao.preco;
        if(comodoAtributoValorUnitario) {
          comodoAtributoVariacaoPreco = comodoAtributoVariacaoPreco * comodoAtributoValorUnitario;
        }
        sumBaseValue += comodoAtributoVariacaoPreco;
        nomesAnteriores.push(comodoAtributoVariacao.nome)
      }
    });
    this.valorBase = sumBaseValue;
    this.sumTotal();
  }

  sumTotal() {
    this.valorTotal = this.selectedApartamento?.preco + this.valorBase + this.valorAdicional;
    this.saveValuesSession();
  }

  getVariationPrice(value) {
    let index = this.selectedVariations.findIndex(v => v.includes(value));
    if(index !== -1) {
      let valueArray = this.selectedVariations[index].split('-');
      let comodoAtributoVariacao = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.id.toString() === valueArray[2] })[0];
      if(comodoAtributoVariacao) {
        let comodoAtributoValorUnitario = comodoAtributoVariacao.comodoAtributo.valorUnitario;
        let comodoAtributoVariacaoPreco = comodoAtributoVariacao.preco;
        if(comodoAtributoValorUnitario) {
          comodoAtributoVariacaoPreco = comodoAtributoVariacaoPreco * comodoAtributoValorUnitario;
        }
        return comodoAtributoVariacaoPreco;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  checkAdditional(event, atributoAdicional: AtributoAdicional) {
    if(event.target.checked) {
      this.selectedAdditionals.push(atributoAdicional.id);
      this.valorAdicional += atributoAdicional.preco;
      this.atributoAdicionalSelecionado = atributoAdicional.id;
    } else {
      let index = this.selectedAdditionals.findIndex(adicionalId => adicionalId === atributoAdicional.id);
      this.selectedAdditionals.splice(index, 1);
      this.valorAdicional -= atributoAdicional.preco;
      this.atributoAdicionalSelecionado = 0;
    }
    this.saveVariationSession();
    this.sumTotal();
  }

  checkAdditionalFromSession() {
    this.additionalsSession.forEach(atributoAdicionalId => {
      let atributoAdicional = this.atributosAdicionais.filter(atributoAdicional => { return atributoAdicional.id === atributoAdicionalId })[0];
      if(atributoAdicional) {
        this.selectedAdditionals.push(atributoAdicional.id);
        this.valorAdicional += atributoAdicional.preco;
        this.atributoAdicionalSelecionado = atributoAdicional.id;
      }
    });
    this.saveVariationSession();
    this.sumTotal();
  }

  checkAtributoAdicionalSession(atributoAdicionalId) {
    let atributoAdicionalSessionId = this.additionalsSession.filter(atributoAdicionalSessionId => { return atributoAdicionalSessionId === atributoAdicionalId })[0];
    if(atributoAdicionalSessionId) {
      return true;
    } else {
      return false;
    }
  }

  checkHabilitarAdicionaisMultiplasSelecoes(atributoAdicional: AtributoAdicional) {
    if(this.atributoAdicionalSelecionado === -1) {
      this.checkAdditionalFromSession();
    }
    if(this.atributoAdicionalSelecionado === atributoAdicional.id || this.atributoAdicionalSelecionado === 0 && this.selectedAdditionals.length === 0 || this.atributoAdicionalSelecionado === -1 && this.selectedAdditionals.length === 0) {
      return true;
    } else {
      return false;
    }
    //atributoAdicionalSelecionado != atributoAdicional.id && habilitarAdicionaisMultiplasSelecoes
  }

  getComodoAtributosByComodo(comodoId: number) {
    let comodoAtributosByComodo = this.comodosAtributos.filter(comodoAtributo => { return comodoAtributo.comodo.id === comodoId });
    return comodoAtributosByComodo;
  }

  getComodoAtributoVariacoesByAtributo(comodoAtributoId: number) {
    let comodoAtributoVariacoesByAtributo = this.comodosAtributosVariacoes.filter(comodoAtributoVariacao => { return comodoAtributoVariacao.status === true && comodoAtributoVariacao.comodoAtributo.id === comodoAtributoId });
    return comodoAtributoVariacoesByAtributo;
  }
  
  displayOptionsMobile() {
    this.optionsMobileEnabled = true;
  }
  
  hiddenOptionsMobile() {
    this.optionsMobileEnabled = false;
  }

  saveVariationSession() {
    let clienteProjetoItens: ClienteProjeto[] = [];
    sessionStorage.setItem('clienteProjeto', null);
    this.selectedVariations.forEach(value => {
      let valueArray = value.split('-');
      let clienteProjeto: ClienteProjeto = {id: undefined, cliente: undefined, comodo: undefined, comodoAtributo: undefined, comodoAtributoVariacao: undefined, atributoAdicional: undefined, cor: '#8e8e8e'};
      clienteProjeto.id = 0;
      clienteProjeto.cliente = this.cliente;
      clienteProjeto.comodo = Number(valueArray[0]);
      clienteProjeto.comodoAtributo = Number(valueArray[1]);
      clienteProjeto.comodoAtributoVariacao = Number(valueArray[2]);
      clienteProjeto.cor = valueArray[3];
      clienteProjetoItens.push(clienteProjeto);
    });
    this.selectedAdditionals.forEach(value => {
      let clienteProjeto: ClienteProjeto = {id: undefined, cliente: undefined, comodo: undefined, comodoAtributo: undefined, comodoAtributoVariacao: undefined, atributoAdicional: undefined, cor: '#8e8e8e'};
      clienteProjeto.id = 0;
      clienteProjeto.atributoAdicional = value;
      clienteProjetoItens.push(clienteProjeto);
    });
    sessionStorage.setItem('clienteProjeto', JSON.stringify(clienteProjetoItens));
  }

  saveValuesSession() {
    this.cliente.valorBase = this.valorBase;
    this.cliente.valorAdicional = this.valorAdicional;
    this.cliente.valorTotal = this.valorTotal;
    sessionStorage.setItem('cliente', JSON.stringify(this.cliente));
  }

  salvarSelecao() {
    this.dataService.saveClienteProjeto(this.cliente.id, JSON.parse(sessionStorage.getItem('clienteProjeto')))
      .subscribe(clienteProjeto => {
        if(this.novoCliente) {
          this.router.navigate(['/decorar-apartamento/sucesso/novo']);
        } else {
          this.router.navigate(['/decorar-apartamento/sucesso/'+this.cliente.codigoUrl]);
        }
      });
  }

  incrementarContador(apartamentoId, tipo) {
    let contador: Contador = {apartamentoId, tipo};
    contador.apartamentoId = apartamentoId;
    contador.tipo = tipo;
    this.dataService.incrementarContador(contador)
      .subscribe();
  }

  incrementarNavegacao(apartamentoId, duration) {
    let navegacao: Navegacao = {apartamentoId: 0, navegacao: ''};
    navegacao.apartamentoId = apartamentoId;
    navegacao.navegacao = this.secondsToHHMMSS(duration);
    this.dataService.incrementarNavegacao(navegacao)
      .subscribe();
  }

  secondsToHHMMSS(secs: number): string {
    let hours = Math.floor(secs / 3600);
    let minutes = Math.floor((secs - (hours * 3600)) / 60);
    let seconds = secs - (hours * 3600) - (minutes * 60);
  
    seconds = Math.round(seconds);
  
    let hoursStr = hours < 10 ? "0" + hours.toString() : hours.toString();
    let minutesStr = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
    let secondsStr = seconds < 10 ? "0" + seconds.toString() : seconds.toString();
  
    return hoursStr + ':' + minutesStr + ':' + secondsStr;
  }

  getFormattedValue(valor: number) {
    return new Intl.NumberFormat('pt-BR',{minimumFractionDigits: 2}).format(valor);
  }
}
